import React from 'react';
import { Table } from 'antd';

const PricingTable = (props) => {
    const { currentDetailCalculation, formData } = props;

    // Helper to format currency
    const formatCurrency = (value) => {
        return value
            ? `$${Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
            : '$0.00';
    };

    // Define data source dynamically based on `currentDetailCalculation`
    const dataSource = [
        {
            key: 'Hardware',
            label: 'Hardware',
            unitCost: currentDetailCalculation['Hardware Rental Price Per Unit'] || 0,
            totalCost: currentDetailCalculation['Hardware Rental Price Total'] || 0,
            oneTimeCost: currentDetailCalculation['One Time Cost Total'] || 0,
            GrandTotal: currentDetailCalculation['Hardware Rental Price Grand Total']
        },
        {
            key: 'Software',
            label: 'Software',
            unitCost: currentDetailCalculation['Software Rental Price per unit'] || 0,
            totalCost: currentDetailCalculation['Software Rental Price Total'] || 0,
            oneTimeCost: currentDetailCalculation['Software One time Cost'] || 0,
            GrandTotal: currentDetailCalculation['Software Rental Price Grand Total'] || 0
        },
        {
            key: 'Total',
            label: 'Total',
            unitCost: currentDetailCalculation['Rental Total Price per Unit'],
            totalCost: currentDetailCalculation['Rental Price Total'] || 0,
            oneTimeCost: (currentDetailCalculation['One Time Cost Total'] || 0),
            GrandTotal: currentDetailCalculation['Rental Price Grand Total'] || 0
        }
    ];

    const dataSource1 = [
        {
            key: 'Hardware',
            label: 'Hardware',
            unitCost: currentDetailCalculation['Hardware Sale Price per unit'] || 0,
            totalCost: currentDetailCalculation['Hardware Sale Price Total'] || 0,
            oneTimeCost: currentDetailCalculation['Hardware One Time Cost'] || 0,
            GrandTotal: currentDetailCalculation['Hardware Sale Price Grand Total']
        },
        {
            key: 'Software',
            label: 'Software',
            unitCost: currentDetailCalculation['Software Sale Price per unit'] || 0,
            totalCost: currentDetailCalculation['Software Sale Price Total'] || 0,
            oneTimeCost: currentDetailCalculation['Software One time Cost'] || 0,
            GrandTotal: currentDetailCalculation['Software Sale Price Grand Total'] || 0
        },
        {
            key: 'Total',
            label: 'Total',
            unitCost: currentDetailCalculation['Sale Total Price per Unit'],
            totalCost: currentDetailCalculation['Sale Price Total'] || 0,
            oneTimeCost: (currentDetailCalculation['One Time Cost Total'] || 0),
            GrandTotal: currentDetailCalculation['Sale Price Grand Total'] || 0
        }
    ];

    // Define columns for the Table component
    const columns = [
        {
            title: 'Items',
            dataIndex: 'label',
            key: 'label',
            width: '20%',
            align: 'left',
            render: (text) => (text === 'Total' ? <strong>{text}</strong> : text),
        },
        {
            title: 'Unit Price',
            dataIndex: 'unitCost',
            key: 'unitCost',
            align: 'right',
            width: '20%',
            render: (value) => formatCurrency(value),
        },
        {
            title: 'Total Price',
            dataIndex: 'totalCost',
            key: 'totalCost',
            align: 'right',
            width: '20%',
            render: (value) => formatCurrency(value),
        },
        {
            title: 'One Time Cost',
            dataIndex: 'oneTimeCost',
            key: 'oneTimeCost',
            align: 'right',
            width: '20%',
            render: (value) => formatCurrency(value),
        },
        {
            title: 'Grand Total',
            dataIndex: 'GrandTotal',
            key: 'GrandTotal',
            align: 'right',
            width: '20%',
            render: (value) => formatCurrency(value),
        },
    ];

    return (
        <div className="pricing-guidance-table-wrap">
            <Table
                style={{ width: '100%', margin: 0, padding: 0 }}
                className="Data360-pricing-table pricing-guidance-table"
                dataSource={formData['Project_details']['License_mode'] == 'Sale' ? dataSource1 : dataSource}
                columns={columns}
                pagination={false}
                size="large"
            />
        </div>
    );
};

export default PricingTable;
